const csvLine = (item, format)=> {
    let elements = [];
    elements.push(item.code);
    elements.push(item.shortLiteral);
    elements.push(item.literal);
    if ( format === 'expanded' ) {
        elements.push(item.description);
        elements.push(item.subjectName);
        let eCodes = [];
        let endorsements = item.endorsements;
        for ( let x in endorsements ) {
            eCodes.push( endorsements[x].endorsement_code+'('+ endorsements[x].endorsement.literal+')' )
        }
        elements.push( eCodes.join(','))
    }

    elements = elements.map(function(e){ return { value: e, type: 'string' } });
    return elements;

};

export default csvLine;
